import styled, { css } from "styled-components";
import { border, color, onHover, typeStyle, units, visuallyHidden } from "@m/alchemy-theme";
import { darken, rgba } from "polished";
import { Control as BinarySelectControl } from "../../binary-select/BinarySelect.styled";
export const ToggleButton = styled.div `
  display: inline-flex;
  align-items: center;

  border: ${border()};
  border-top-right-radius: ${units(2.25)};
  border-bottom-right-radius: ${units(2.25)};
  border-top-left-radius: ${units(2.25)};
  border-bottom-left-radius: ${units(2.25)};
  overflow: hidden; /* so only this div needs rounded corners */

  [data-whatinput="keyboard"] &:focus-within {
    ${(props) => css `
      ${props.activeColorScheme === "alchemyBrand"
    ? css `
            box-shadow:
              0px 0px 0px 2px ${color("container")},
              0px 0px 0px 4px ${rgba(color("inverse")(props), 0.6)};
          `
    : css `
            box-shadow:
              0px 0px 0px 2px ${color("inverse")},
              0px 0px 0px 4px ${color("base")};
          `}
    `}
  }
  /* input display none for safari, BinarySelectControl is the "real" checkbox so needs to be hidden */
  ${BinarySelectControl},
  input {
    ${visuallyHidden()}
  }

  label {
    padding: 0;
    width: 100%;
    align-self: stretch;
  }
`;
export const ToggleButtonContent = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  flex-shrink: 0;

  ${typeStyle("actionM")};
  color: ${({ ...props }) => darken(0.035, color("base")(props))};
  width: 100%;
  min-height: ${units(3.25)};
  height: 100%;
  word-break: break-all;
  padding: ${units(0.5)} ${units(2)};
  border: none;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  ${({ disabled }) => disabled && `opacity: 0.35;`};

  ${({ disabled, isChecked, ...props }) => !disabled &&
    css `
      ${onHover(css `
        background-color: ${isChecked ? darken(0.04, color("hint")(props)) : darken(0.01, color("hint")(props))};
        box-shadow: inset 0 2px 4px 0 rgba(46, 119, 208, 0.12);
      `)}
    `}

  ${({ isChecked }) => isChecked &&
    css `
      background-color: ${color("hint")};
    `}
`;
export const ToggleButtonVisuallyHiddenLabel = styled.span `
  ${visuallyHidden()}
`;
export const ToggleButtonIconWrapper = styled.span `
  display: inline-block;
  margin-right: ${units(1)};
  height: ${units(2)};
`;
